// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6905":"css/admin-app.7036","8274":"css/app.7036"}[chunkId] + ".css";
};